// Theme System Controller - Simplified Working Implementation
// Handles dark/light mode switching, system preference detection, and persistence
// ------------------------------------------------------------

// Initialize theme system immediately when script loads
(function() {
  const KEY = 'theme';
  const system = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  const stored = localStorage.getItem(KEY);
  const requested = stored || system;              // default to system if nothing stored
  
  applyTheme(requested);

  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(KEY, theme);
    window.__theme = theme;
    
    // Update toggle button icon if it exists
    updateToggleIcon(theme);
  }

  function updateToggleIcon(theme) {
    const toggleBtn = document.querySelector('[data-action="toggle-theme"]');
    if (toggleBtn) {
      const icon = toggleBtn.querySelector('.theme-icon');
      if (icon) {
        icon.innerHTML = theme === 'dark' ? 
          '<svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"/></svg>' :
          '<svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/></svg>';
      }
    }
  }

  // Set up event listener when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    // Update toggle icon on load
    updateToggleIcon(window.__theme);
    
    // Set up click handler
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-action="toggle-theme"]');
      if (!btn) return;
      
      e.preventDefault();
      applyTheme((window.__theme === 'dark') ? 'light' : 'dark');
    });
  });

  // Listen for system theme changes
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function(e) {
    // Only auto-switch if user hasn't manually set a preference
    if (!localStorage.getItem(KEY)) {
      applyTheme(e.matches ? 'dark' : 'light');
    }
  });

})();

// Export a default function for webpack compatibility
export default function ThemeController() {
  // The IIFE above handles everything, this is just for module compatibility
  return {
    initialized: true
  };
}
